import { useEffect } from "react";

/**
 * Sets a class on <body> matching the Marionette router's _addBodyClass behavior.
 * Marionette does: $('body').attr('class', 'page-' + route)
 */
export function useBodyClass(className) {
  useEffect(() => {
    const body = document.body;
    const previous = body.className;
    body.className = className;
    return () => {
      body.className = previous;
    };
  }, [className]);
}
